const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const FixedAssetsHeader = [
    { field: 'id', headerName: '#', width: 90, headerClassName: 'super-app-theme--header', groupable: false, aggregable: true },
    { field: 'accname', headerName: 'Emertimi', width: 400, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'date', headerName: 'Data', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    // { field: 'client', headerName: 'Furnitori', width: 210, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'vleraBruto', headerName: 'Vlera Bruto', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'zhvlersimi', headerName: 'Zhvleresimi', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
    {
        field: 'vleraNeto', headerName: 'Vlera Neto', type: 'string', width: 200, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

